/* Datapeople accounts used for testing/prod uptime metrics in AWS Canary */

/**
 * @constant {number}
 * @memberof Constants
 */

export const CANARY_PROD = 2559537;
export const CANARY_TEST = 2176889;
